// extracted by mini-css-extract-plugin
export default {"BriefForm":"BriefForm--dsnfg","BriefForm__container":"BriefForm__container--cERJ6","BriefForm__recaptcha":"BriefForm__recaptcha--mu7R9"};